import { render, staticRenderFns } from "./SignFiles.vue?vue&type=template&id=1c8ad5f4&"
import script from "./SignFiles.vue?vue&type=script&lang=js&"
export * from "./SignFiles.vue?vue&type=script&lang=js&"
import style0 from "./SignFiles.vue?vue&type=style&index=0&id=1c8ad5f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports